import {deviceUtil,pageUtil} from "@repo/lib-common";
import {Bid, BidderParamMap} from './pbjsTypes';
import {SingleSizeArray} from "./googleTypes";

/** prebid /header bidding bidder class
 *
 * */
export class Bidder {
    static builder( code:string):Bidder {
        return new Bidder(code);
    }
    constructor( code:string){
        this.code=code;
    }
    code: string;
    isEnabled: boolean = false;
    params: BidderParamMap = {};
    isAnyDeviceAllowed: boolean = false;
    allowedDevices: deviceUtil.DeviceTypeArray = [];

    isAnySizeAllowed: boolean = false;
    allowedSizes: SingleSizeArray = [];

    
    allowedPageTypes: pageUtil.PageTypeArray = [];

    setIsEnabled(value: boolean): Bidder {
        this.isEnabled = value;
        return this;
    }
    setCode(value: string): Bidder {
        this.code = value;
        return this;
    }
    setParams(value: BidderParamMap): Bidder {
        this.params = value;
        return this;
    }

    //size -->
    setIsAnySizeAllowed(value: boolean): Bidder {
        this.isAnySizeAllowed = value;
        return this;
    }
    setAllowedSizes(value: SingleSizeArray): Bidder {
        this.isAnySizeAllowed=false;
        this.allowedSizes = value;
        return this;
    }
    //size <--

    //device -->
    setIsAnyDeviceAllowed(value: boolean): Bidder {
        this.isAnyDeviceAllowed = value;
        return this;
    }
    setAllowedDevices(value: deviceUtil.DeviceTypeArray): Bidder {
        this.allowedDevices = value;
        return this;
    }
    //device <--

    toBidObj(){
        return { bidder: this.code, params:this.params} as Bid;
    }
}
